export default function SocialIcons({ link, target = "_blank", logo, name }) {

    return (
        <>
            {link && link !== null &&
                <li>
                    <a href={link} target={target}>
                        {logo}
                        {name}
                    </a>
                </li>
            }
        </>
    )
}